import React from "react";
import { usePreguntasCalidad } from "../../hooks";
import { Preguntas } from "../Preguntas";
import usePreguntasPuntualidad from "../../hooks/usePreguntasPuntualidad";
import usePreguntasComunicacionReportes from "../../hooks/usePreguntasComunicacionReportes";
import usePreguntasResponsabilidadManejoVehiculo from "../../hooks/usePreguntasResponsabilidadManejoVehiculo";
import usePreguntasActitudTrabajoEquipo from "../../hooks/usePreguntasActitudTrabajoEquipo";
import usePreguntasCalidadTrabajo from "../../hooks/usePreguntasCalidadTrabajo";
import usePreguntasResponsabilidadPuntualidad from "../../hooks/usePreguntasResponsabilidadPuntualidad";
import usePreguntasTrabajoEnEquipoActitud from "../../hooks/usePreguntasTrabajoEnEquipoActitud";
import usePreguntasResolucionProblemaTomaDecisiones from "../../hooks/usePreguntasResolucionProblemaTomaDecisiones";

const PreguntasResolucionProblemaTomaDecisiones = () => {
	const { frmPreguntas, setPuntajeTotal } = usePreguntasResolucionProblemaTomaDecisiones();

	return (
		<Preguntas
			form={frmPreguntas}
			calcularPuntajeTotal={setPuntajeTotal}
			titulo="Resolución de problema y toma de decisiones (6/6)"
			opciones={[
				{ key: "identificaRapidamenteLaCausaRaizFalla", label: "Identifica rápidamente la causa raíz de una falla" },
				{ key: "actuaConCriterioAnteSituacionesImprevistas", label: "Actúa con criterio ante situaciones imprevistas" },
				{ key: "proponeSolucionesPracticasYEfectivas", label: "Propone soluciones prácticas y efectivas" }]}
		/>
	);
};

export default PreguntasResolucionProblemaTomaDecisiones;
